/**
 * Checks if 2 values are roughly the same. If 2 numbers, they must be exactly the same value. If 2 strings, the lower case versions are compared. If the types don't match, false is returned
 * @param {*} val1
 * @param {*} val2
 */
export default function(val1, val2) {
    if (typeof val1 == 'number' || typeof val2 == 'number') {
        return parseInt(val2) == parseInt(val1);
    }
    if (typeof val1 == 'string' && typeof val2 == 'string') {
        return val2.toLowerCase() == val1.toLowerCase();
    }
    if (typeof val1 !== typeof val2) {
        return false;
    }
    return val2 == val1;
};